import {Component} from '@angular/core';
import {TranslateModule} from '@ngx-translate/core';
import {DatePipe} from '@angular/common';
import {AppInformationService} from '../../services/app-information.service';
import {LanguageService} from '../../services/language.service';
import {NavigationService} from '../../services/ionic/navigation.service';
import {routeUrls} from '../../constants/route-urls';
import {TapDirective} from '../../directives/tap.directive';
import {IonText} from '@ionic/angular/standalone';

@Component({
    selector: 'app-app-information',
    templateUrl: './app-information.component.html',
    styleUrls: ['./app-information.component.scss'],
  imports: [TranslateModule, DatePipe, IonText]
})
export class AppInformationComponent {

  public constructor(public languageService: LanguageService,
                     public appInformationService: AppInformationService,
                     private navigationService: NavigationService) {
  }

}
